module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "goodsList-div"
  }, [_c('div', {
    staticClass: "index-wrapper"
  }, [_c('mall-header'), _vm._v(" "), _c('div', {
    staticClass: "goodsList-content",
    staticStyle: {
      "background-image": "url('../../static/images/BNNER.png')",
      "background-position": "center"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "accessory-result-page accessory-page"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    ref: "accHock",
    staticClass: "container"
  }, _vm._l((_vm.goodsMap), function(value, key) {
    return _c('div', [_c('div', {
      staticStyle: {
        "margin-top": "25px"
      }
    }, [_c('span', {
      staticClass: "DZ-class"
    }, [_vm._v(_vm._s(key))])]), _vm._v(" "), _c('div', {
      staticClass: "goodsList-all-div",
      attrs: {
        "id": "pro_form"
      }
    }, [_c('div', [_c('el-row', _vm._l((value), function(datas, index) {
      return _c('el-col', {
        key: index,
        style: (index % 4 == 0 ? 'margin-left: 0px !important;' : ''),
        attrs: {
          "span": 4,
          "offset": index
        }
      }, [_c('el-card', {
        staticClass: "el-card-css",
        attrs: {
          "body-style": {
            padding: '0px',
            height: '422px'
          },
          "shadow": "hover"
        }
      }, [_c('div', [_c('div', {
        on: {
          "click": function($event) {
            return _vm.openGoodList(datas)
          }
        }
      }, [_c('a', [_c('img', {
        staticClass: "span-img-css",
        attrs: {
          "src": datas.imgUrl,
          "alt": ""
        }
      })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-tooltip', {
        attrs: {
          "placement": "right",
          "popper-append-to-body": false,
          "disabled": _vm.showTooltip,
          "content": datas.name
        }
      }, [_c('div', {
        staticClass: "span-font-titel",
        on: {
          "mouseenter": function($event) {
            return _vm.showTips($event)
          }
        }
      }, [_vm._v(_vm._s(datas.name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-tooltip', {
        attrs: {
          "placement": "right",
          "popper-append-to-body": false,
          "disabled": _vm.isShowTooltip,
          "content": datas.description
        }
      }, [_c('div', {
        staticClass: "span-font-css",
        on: {
          "mouseenter": function($event) {
            return _vm.descriptionTips($event)
          }
        }
      }, [_vm._v(_vm._s(datas.description))])]), _vm._v(" "), _c('span', {
        staticClass: "span-money-css"
      }, [_vm._v("￥" + _vm._s(datas.unitPrice))])], 1)])])], 1)
    }), 1)], 1), _vm._v(" "), _c('el-backtop', {
      staticStyle: {
        "right": "initial",
        "bottom": "40px"
      }
    }, [_c('div', {
      staticClass: "el-backtop-div"
    }, [_c('img', {
      staticStyle: {
        "margin-top": "15px"
      },
      attrs: {
        "src": require("../../static/images/backtop.png")
      }
    })])])], 1)])
  }), 0)])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "left": "0px",
      "bottom": "0px",
      "width": "100%",
      "z-index": "1",
      "text-align": "center",
      "padding": "20px 0",
      "color": "#999999",
      "font-size": "14px"
    }
  }, [_vm._v("\n  Copyright ©2021 深圳市东宝信息技术有限公司 All Rights Reserved\n")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77b6b77e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/GoodsList.vue
// module id = 336
// module chunks = 2